import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, CheckCircle2, PenTool, Search, Wind, Heart, Compass } from 'lucide-react';
export function SuccessStories() {
  const benefits = [{
    icon: <PenTool className="w-6 h-6" data-id="element-153" />,
    title: 'Ejercicios de reflexión guiada.',
    description: 'Preguntas diseñadas para profundizar en tu interior sin juzgarte.'
  }, {
    icon: <Search className="w-6 h-6" data-id="element-154" />,
    title: 'Herramientas para identificar emociones bloqueadas.',
    description: 'Aprendé a ponerle nombre a lo que sentís para poder procesarlo.'
  }, {
    icon: <Wind className="w-6 h-6" data-id="element-155" />,
    title: 'Técnicas simples para comenzar a soltar.',
    description: 'Métodos prácticos que podés aplicar en tu día a día.'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-156" />,
    title: 'Espacios para escribir y reconectar con vos.',
    description: 'Tu propio refugio digital para volcar tus pensamientos.'
  }, {
    icon: <Compass className="w-6 h-6" data-id="element-157" />,
    title: 'Actividades prácticas para tu bienestar emocional.',
    description: 'Pasos concretos para recuperar tu paz mental.'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-158" />,
    title: 'Recursos para acompañarte paso a paso.',
    description: 'No estás solo en este proceso, el kit te guía en cada etapa.'
  }];
  return <section id="beneficios" className="py-24 px-4 relative overflow-hidden bg-[#0f0720] pt-[20px] pb-[20px]" data-id="element-159">
      <div className="max-w-7xl mx-auto" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-violet-500/10 border border-violet-500/30 text-violet-300 text-sm font-medium mb-6" data-id="element-162">
            <Sparkles className="w-4 h-4" data-id="element-163" />
            <span data-id="element-164">Contenido del Kit</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-165">
            ¿Qué vas a encontrar dentro?
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-166">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group p-8 rounded-3xl bg-violet-900/10 border border-white/5 hover:border-violet-500/30 transition-all duration-300" data-id="element-167">
              <div className="w-12 h-12 rounded-2xl bg-violet-500/20 flex items-center justify-center text-violet-400 mb-6 group-hover:scale-110 transition-transform" data-id="element-168">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 flex items-center gap-2" data-id="element-169">
                <CheckCircle2 className="w-5 h-5 text-violet-500 shrink-0" data-id="element-170" />
                {benefit.title}
              </h3>
              <p className="text-violet-200/70 leading-relaxed" data-id="element-171">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Wavy Divider */}
      <div className="wave-divider top" data-id="element-172">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-173">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-violet-950 opacity-10" data-id="element-174"></path>
        </svg>
      </div>
    </section>;
}